<template>
  <div>
    <body class="" style="margin-bottom:0;">
      
      <div class="topbar-wrap">
        
        <div class="topbar is-sticky" style="left:0;right:0">
          <div class="container">
            <div class="d-flex justify-content-between align-items-center">
              <!-- <ul class="topbar-nav d-lg-none">
                
                <li class="topbar-nav-item relative">
                  
                   <a  class="toggle-nav" href="#">
                                <div class="toggle-icon">
                                    <span class="toggle-line"></span>
                                    <span class="toggle-line"></span>
                                    <span class="toggle-line"></span>
                                    <span class="toggle-line"></span>
                                </div>
                            </a>
                </li>
              </ul> -->

              
              <!-- .topbar-nav -->
              <span style="cursor:pointer" @click="toHome" class="topbar-logo">
                <img
                style="height:75px;width:170px"
                  src="../assets/bdt2.png"
                  alt="logo"
                />
              </span>
              <ul class="topbar-nav">
                <li class="topbar-nav-item relative">
                  <span class="user-welcome d-none d-lg-inline-block"
                    >Welcome!</span
                  >
                  <span
                    v-if="$store.state.name != '' && kycDone"
                    class="user-welcome d-none d-lg-inline-block font-bold"
                    >{{ $store.state.name }}</span
                  >
                  <span
                    v-else-if="$store.state.name != '' && isParty"
                    class="user-welcome d-none d-lg-inline-block font-bold"
                    >Partner {{ $store.state.name }}</span
                  >
                  <span
                    v-else-if="$store.state.name != '' && isGov"
                    class="user-welcome d-none d-lg-inline-block font-bold"
                    >Government of {{ $store.state.name }}</span
                  >

                  <!-- <em class="ti ti-user"></em> -->
                
                  <v-gravatar
                    :email="this.currentAddress"
                   
                  @click="showDrop"
                   
                    alt="Nobody"
                   
                    style="border-radius:5px;border:white solid 2px;cursor:pointer;margin-right:0px;"
                    :size="35"
                    default-img="retro"
                  />
                 

                  <div
                    id="dropdown"
                    style="overflow:auto;z-index:5000px;"
                    class="toggle-class dropdown-content dropdown-content-right dropdown-arrow-right user-dropdown"
                  >
                    <div class="user-status">
                      <h6 class="user-status-title">TRX balance</h6>
                      <div class="user-status-balance">
                        {{ this.$store.state.currentBalance }}
                        <small>TRX</small>
                      </div>
                      <hr
                        style="background-color: white; height: 1px; border: 0; margin-top:15px;margin-bottom:15px;"
                      />
                      <div v-if="isParty && special==false">
                        <h6 class="user-status-title">
                          Deposited amount in your pool
                        </h6>
                        <div class="user-status-balance">
                          <span style="display:inline-block"
                            >{{ this.$store.state.depositedAmount }}
                            <small>TRX</small>
                          </span>
                          <span style="left:10px;margin-left:15px;"
                            ><button
                              class="m-0  pt-0"
                              style="margin-top:0;padding-top:0;border-radius:5px; background-color:transparent;border:2px white solid;color:white;cursor:pointer"
                              @click="depositAmount"
                            >
                              <i
                                style="font-size:13px;bottom:2px;display:inline-block;position:relative"
                                class="fa fa-plus px-1"
                              ></i></button
                          ></span>
                        </div>
                        <hr
                          style="background-color: white; height: 1px; border: 0; margin-top:15px;margin-bottom:15px;"
                        />
                        <h6 class="user-status-title">
                          MIMA token balance
                        </h6>
                        <div class="user-status-balance">
                          <span style="display:inline-block"
                            >{{ this.mimaBalance }}
                            <small>MIMA</small>
                          </span>
                        </div>
                        <hr
                          style="background-color: white; height: 1px; border: 0; margin-top:15px;margin-bottom:15px;"
                        />
                      </div>
                      <h6 class="user-status-title">TRX address</h6>
                      <div
                        style="color:white;"
                      >
                        <span class="d-lg-none"  style="display:inline-block;margin-right:10px;">
                          <span>
                          {{ this.currentAddress.slice(0, 15) }}....{{
                            this.currentAddress.slice(32, 42)
                          }}</span>
                          <span
                            style="display:inline-block;;position:absolute;right:18px;"
                          >
                            <btn
                              v-clipboard="this.currentAddress"
                              class="ml-2"
                              @success="success"
                              style="cursor:pointer;display:inline-block;right:0px;position:relative"
                              @error="failed"
                            >
                              <em
                                style="background:transparent"
                                class="fas fa-copy"
                              ></em>
                            </btn>
                          </span>
                        </span>

                        <span
                          style="display:inline-block;margin-right:10px;"
                          class="d-none d-lg-block "
                        >
                          {{ this.currentAddress }}

                          <span
                            style="display:inline-block;position:absolute;right:15px;"
                          >
                            <btn
                              v-clipboard="this.currentAddress"
                              class="ml-2"
                              @success="success"
                              style="cursor:pointer;display:inline-block"
                              @error="failed"
                            >
                              <em
                                style="background:transparent"
                                class="fas fa-copy"
                              ></em>
                            </btn>
                          </span>
                        </span>
                      </div>
                      <hr
                        v-if="isGov || isParty"
                        style="background-color: white; height: 1px; border: 0; margin-top:15px;margin-bottom:15px;"
                      />
                      <h6 v-if="isGov || isParty" class="user-status-title">
                        Registered Email address
                      </h6>
                      <div v-if="isGov || isParty" style="color:white;">
                        {{ this.$store.state.email }}
                      </div>
                    </div>

                    <!-- <div class="user-status" style="color:white">
                   
                  </div>-->

                    <ul
                      @click="logout"
                      style="cursor:pointer"
                      class="user-links mt-1 py-2"
                    >
                      <li>
                        <router-link to="/">
                          <i
                            style="text-size:70px;"
                            aria-hidden="false"
                            class="fa fa-sign-out-alt fa-lg mr-2"
                          ></i
                          >Logout
                        </router-link>
                      </li>
                    </ul>
                      <hr class="m-0 p-0">
                     <ul
                      @click="deleteLogout"
                      style="cursor:pointer"
                      class="user-links my-0 py-2"
                    >
                      <li>
                        <router-link to="/">
                          <i
                            style="text-size:70px;"
                            aria-hidden="false"
                            class="fa fa-trash-alt fa-lg mr-2"
                          ></i
                          >Delete wallet and Logout
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- .topbar-nav-item -->
              </ul>

              <!-- .topbar-nav -->
            </div>
          </div>

          <!-- .container -->
        </div>

        <!-- .topbar -->
        <nav class="navbar navbar-mobile">
          <div class="container">
            <div class="navbar-innr">
              <ul class="navbar-menu mx-auto">
                <li>
                  <router-link
                    exact
                    exact-active-class="activeClass"
                    style="margin-top:10px;"
                    to="/"
                  >
                    <em class="ikon ikon-dashboard"></em> Dashboard
                  </router-link>
                </li>

                <li v-if="isParty">
                  <router-link
                    exact
                    exact-active-class="activeClass"
                    style="margin-top:10px;"
                    to="/history"
                  >
                    <em class="fa fa-history" style="margin-right:10px;"></em
                    >History
                  </router-link>
                </li>
               
                <li v-if="isBlocked == false">
                  <router-link
                    exact
                    exact-active-class="activeClass"
                    style="margin-top:10px"
                    to="/profile"
                  >
                    <em class="ikon ikon-user"></em> Profile
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

      
         
      <!-- <div  class="navbar d-lg-none"> 
        <div class="container">
          <div class="navbar-inner">
                <ul  class="navbar-menu">
                <li>

                
                  <router-link
                  
                
                    
                    exact-active-class="activeClass"
                    style="margin-top:10px;"
                    to="/"
                  >
                    <em class="ikon ikon-dashboard"></em> Dashboard
                  </router-link>
                </li>

                <li v-if="isParty">
                  <router-link
                    exact
                   
                    exact-active-class="activeClass"
                    style="margin-top:10px;"
                    to="/history"
                  >
                    <em class="fa fa-history" style="margin-right:10px;"></em
                    >History
                  </router-link>
                </li>

                <li v-if="isBlocked == false">
                  <router-link
                    exact
                    exact-active-class="activeClass"
                    style="margin-top:10px"
                    to="/profile"
                  >
                    <em class="ikon ikon-user"></em> Profile
                  </router-link>
                </li>
              </ul>
          </div>
        </div>

      </div> -->
       

       

        <!-- .navbar -->
      </div>
      <div data-backdrop="false" class="modal fade" id="myModalWarn">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title font-weight-bold">Insufficient Balance</h4>
              <!-- <button @click="email=''" type="button" data-dismiss="modal" class="close">&times;</button> -->
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <h5>
                 You don't have enough balance to make payment of 5000 TRX or more.
              </h5>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
              <center>
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-primary"
                >
                  Close
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </body>
    <div data-backdrop="false" class="modal my-auto fade fade-enter" id="depositModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Enter password to sign the transaction</h4>
            <button type="button" @click="pk='';password=''" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <div class="modal-body">
             <div class="input-item input-with-label">
              <label class="input-item-label">
                Enter amount you want to deposit
                <span class="text-danger">*</span>
              </label>
              <input
                type="number"
                v-model="paymentAmount"
                class="input-bordered"
              />
            </div>


            <div class="input-item input-with-label">
              <label class="input-item-label">
                Password
                <span class="text-danger">*</span>
              </label>
              <input
                type="password"
                v-model="password"
                class="input-bordered"
              />
            </div>
          </div>

          <div class="modal-footer">
            <button
              @click="depositAmount"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- <div data-backdrop="false" class="modal my-auto fade fade-enter" id="makePaymentModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Enter amount u want to deposit</h4>
            <button type="button" @click="pk='';password='';paymentAmount=0" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <div class="modal-body">
            <div class="input-item input-with-label">
              <label class="input-item-label">
               Amount
                <span class="text-danger">*</span>
              </label>
              <input
                type="number"
                v-model="paymentAmount"
                class="input-bordered"
              />
            </div>
          </div>

          <div class="modal-footer">
            <button
              @click="depositAmount"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
//import { KYC } from "../../embarkArtifacts/contracts";

import { decrypt } from "../utils/crypto";
import axios from "axios"


export default {
  data() {
    return {
      kycDone: false,
      special:false,
      isOpened: false,
      pk: "",
      mimaBalance: 0,
      paymentAmount:0,
      toggleNavBar: false,
      isBlocked: false,
      password: "",
      isGov: false,
      isParty: false,
      currentAddress: this.$cookies.get("address"),
      tronWeb: this.$store.state.tronWeb,
    };
  },

  name: "Nav",

  methods: {
    closeNav() {
      this.toggleNavBar=true;
      // $('.toggle-nav').toggle();
    },
    logout() {
   
      this.$cookies.remove("address");
         this.$cookies.remove("idType");
            this.$cookies.remove("name");
      this.$router.go({ path: "/login" });
    },
    deleteLogout(){
     this.$cookies.remove("address");
      this.$cookies.remove("idType");
            this.$cookies.remove("name");
     if(localStorage.wallet){
     localStorage.removeItem('wallet');
     }else{
     localStorage.removeItem('wallet_tronWeb');
     }
     localStorage.removeItem('isPk')
     localStorage.removeItem('isSeed')
      this.$router.go({ path: "/login" });
    },
    toHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
    showDrop(e) {
      // e.preventDefault();
      window.$(".toggle-class").toggle();
    },
    success() {
      this.$toasted.global.my_app_success({
        message: "Address copied to clipboard",
      });
    },
    failed() {
      this.$toasted.global.my_app_error({
        message: "Address copied to clipboard",
      });
    },

    async getMimaBalance() {
     let amt=await this.$store.state.Token.balanceOf(this.currentAddress).call()
      this.mimaBalance = await this.tronWeb.fromSun(amt.toString());
      if (this.mimaBalance <= 0) {
        this.mimaBalance = parseFloat(this.mimaBalance).toFixed(2);
      } else if (this.mimaBalance > 0) {
        this.mimaBalance = parseFloat(this.mimaBalance).toFixed(2);
      }
    },
    async getName() {
      try {
        console.log(this.currentAddress);
        let gov = await this.$store.state.KYC
          .isGov(this.currentAddress)
          .call();
        console.log(gov);

        let party = await this.$store.state.KYC
          .isParty(this.currentAddress)
          .call();
        if (gov) {
          this.isGov = true;
          let details = await this.$store.state.KYC
            .getGovDetails(this.currentAddress)
            .call({ from: this.currentAddress });
              let key = process.env.VUE_APP_API_KEY;
          let getData = await axios({
            url: this.$store.state.url+"/api/user/getVal",

            method: "POST",
            data: {
              val:details[0]
            },
            headers: {
              Authorization: "Basic " + key
            }
          });
          await this.$store.dispatch("getName", details[1]);
          
          this.$store.state.email =getData.data.val;
        } else if (party) {
          this.isParty = true;

          let details = await this.$store.state.KYC
            .getPartyDetails()
            .call({ from: this.currentAddress });
            this.special=details.isSpecial;
          await this.$store.dispatch("getName", details.partyName);

             let key = process.env.VUE_APP_API_KEY;
          let getData = await axios({
            url: this.$store.state.url+"/api/user/getVal",

            method: "POST",
            data: {
              val:details.email
            },
            headers: {
              Authorization: "Basic " + key
            }
          });
          this.$store.state.email = getData.data.val
        } else if (this.kycDone) {
          console.log("here");
           await this.$store.dispatch("getName", this.$cookies.get('name'));
          // let personalData = await this.$store.state.KYC
          //   .getPersonalUserDetails(this.currentAddress)
          //   .call({ from: this.currentAddress });
          // let name = await decrypt(personalData.fullName);
          // await this.$store.dispatch("getName", name);
        }
      } catch (err) {
        console.log("Error:", err);
      }
    },
      async checkStatus(id) {
      let vm = this;
      let timer = setInterval(async () => {
        let info = await vm.$store.state.tronWeb.trx.getTransactionInfo(id);
        console.log(info);
        if (info.receipt.result == "SUCCESS") {
           clearInterval(timer);
           
          this.$store.state.loading = false;
          console.log(info);
          this.$toasted.global.my_app_success({
            message: "Transaction completed",
          });
          await this.$store.dispatch("getDepositedAmount", this.currentAddress);
          await this.$store.dispatch("getCurrentBalance", this.curretAddress);
         
        } else if (info.result == "FAILED") {
           clearInterval(timer);
          this.$store.state.loading = false;
          console.log(info);
          this.$toasted.global.my_app_error({
            message: "Transaction failed",
          });
         
        }
      }, 1000);
    },
    async depositAmount() {
     
      try {
        await this.$store.dispatch("getCurrentBalance", this.currentAddress);
        if (this.$store.state.currentBalance < 5000) {
          window
            .$("#myModalWarn")
            .modal({ backdrop: "static", keyboard: false, show: true });
        }
       
        else {
          if(this.paymentAmount==0){
           
           window
            .$("#depositModal")
            .modal({ backdrop: "static", keyboard: false, show: true })
          }
         else if(this.paymentAmount<5000)
          {

           this.$toasted.global.my_app_error({
            message: "You need to deposit minimum 5000 TRX",
          });
          }
         
            else if(this.password == "") {
            
           this.$toasted.global.my_app_error({
            message: "Please enter password",
          });
          } else if (this.password != "") {
            // this.$store.state.loading = true;
            try{
            await this.loginKeyStore();
           
          this.$store.state.loading = true;
          var options = {
            feeLimit: 20000000,
            callValue: this.$store.state.tronWeb.toSun(this.paymentAmount),
            // tokenValue:10,
            // tokenId:1000001
          };
          let params = [
            // { type: "address", value: this.name },
            // { type: "string", value: "Poland" },
            // { type: "string", value: "ironman5@gmail.com" },
          ];

          // await this.$store.state.tronWeb.setPrivateKey(
          //   "501AD9779D596A58E004BFDF51848FFF7D6E6C65D2CF914E149067FADA45162B"
          // );
          let tx = await this.$store.state.tronWeb.transactionBuilder.triggerSmartContract(
            this.$store.state.tronWeb.address.toHex(this.$store.state.address),
            "depositAmount()",
            options,
            params,
            this.$store.state.tronWeb.address.toHex(this.currentAddress)
          );
          console.log("transacion:", tx);
          // .then(res => {
          //   console.log(res)
          // })
          // .catch(err => {
          //   console.log(err)
          // })
          // async (err, transaction) => {
          //   if (err) return console.error(err)

          //   console.group('Unsigned trigger smart contract transaction')
          //   // console.log('- Contract Address: TA2x74755e7UZXGHWbw4CP1FZbEVvpFP9m')
          //   console.log(
          //     '- Transaction:\n' + JSON.stringify(transaction, null, 2),
          //     '\n'
          //   )
          //   console.groupEnd()
          // }

          const signedTransaction = await this.$store.state.tronWeb.trx.sign(
            tx.transaction,
            this.pk
          );
          console.group("Signed  transaction");
          // console.log(
          //   '- Transaction:\n' + JSON.stringify(signedTransaction, null, 2),
          //   '\n'
          // )
          console.groupEnd();

          await this.$store.state.tronWeb.trx.sendRawTransaction(
            signedTransaction,
            async (err, result) => {
              if (err) {
                console.error(err);
              }

              console.group("Broadcast transaction");
              console.log(
                "- Result:\n" + JSON.stringify(result, null, 2),
                "\n"
              );
              console.log(tx.transaction.txID);
              await this.checkStatus(tx.transaction.txID);
              //let interval=setInterval(this.checkStatus("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2"),5000);
              //  ("abae87085c017dc7f6d0134288692c7232f7d03807cf6df9426541f59008d3b2");

              console.groupEnd();
            }
            
          );
        
            }
            catch(err){
               this.pk=""
        this.password=""
        console.log(err);
            }
          
          }
        }
      } catch (err) {
        this.pk=""
        this.password=""
        console.log(err);
      } finally {
       
      }
    },
      async loginKeyStore() {
      if (localStorage.wallet) {
       
        try {
        
           this.$store.state.loading = true;
          let wallet=await decrypt(this.password,localStorage.wallet);
          console.log(wallet)
          //wallet=JSON.parse(wallet)
          this.pk=wallet.privateKey;
            window
              .$("#depositModal")
              .modal("hide")
              

         
                
        } catch (err) {
          console.log(err)
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "Please enter correct password",
          });
          throw err;
        }
      } 
      
      else {
        this.$toasted.global.my_app_error({
          message: "Wallet is not available",
        });
      }
    },
  },

  async mounted() {
    
   
    
  
var $win = $ (window)

function winwidth () {
    return $win.width ();
  }
  var wwCurrent = winwidth ();
  $win.on ('resize', function () {
    wwCurrent = winwidth ();
  });

   

  


      var $is_sticky = $ ('.is-sticky'),
    $topbar = $ ('.topbar'),
    $topbar_wrap = $ ('.topbar-wrap');
  if ($is_sticky.length > 0) {
    var $navm = $is_sticky.offset ();
    $win.scroll (function () {
      var $scroll = $win.scrollTop (), $topbar_height = $topbar.height ();
      if ($scroll > $navm.top) {
        if (!$is_sticky.hasClass ('has-fixed')) {
          $is_sticky.addClass ('has-fixed');
          $topbar_wrap.css ('padding-top', $topbar_height);
        }
      } else {
        if ($is_sticky.hasClass ('has-fixed')) {
          $is_sticky.removeClass ('has-fixed');
          $topbar_wrap.css ('padding-top', 0);
        }
      }
    });
  }

   
  },
  async created() {
    try {
      this.$store.state.tronWeb
      await this.$store.dispatch('setContract');
      await this.$store.dispatch("getDepositedAmount", this.currentAddress);
      this.kycDone = await this.$store.state.KYC
        .KYCDone(this.currentAddress)
        .call();
      this.isBlocked = await this.$store.state.KYC
        .blocked(this.currentAddress)
        .call();

      await this.getName();

     await this.getMimaBalance();
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
<style>
@import "../assets/css/style.css";
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";



/* li.router-link-active {
  border: 1px solid black;
  color: yellow;
} */
.activeClass {
  border-bottom: 3px solid;
  border-bottom-color: #2c80ff;
}


</style>
